<div class="example-container mat-elevation-z8 overflow"  *ngIf="DataSource">
  <mat-table    [dataSource]="DataSource" matSort >

    <mat-header-row *matHeaderRowDef="DisplayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: DisplayedColumns"></mat-row>

    <ng-container matColumnDef="monto">
        <mat-header-cell *matHeaderCellDef>monto</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.monto }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="igv">
      <mat-header-cell *matHeaderCellDef>igv</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.igv }}</mat-cell>
  </ng-container>

   </mat-table>
   <br>
    <div style="display: flex;align-items: center; justify-content: space-around;">

      <button mat-raised-button color="warn" (click)="close()">Cerrar</button>
    </div>
  <br>
</div>
